import * as AttachFile from './AttachFile/ui/AttachFile.css';
import * as UploadedFile from './UploadedFile/ui/UploadedFile.css';
export default {
    AttachFile,
    UploadedFile
};
